import './styles.css';
import React from 'react';


function Badge({ className, line1, line2, line3, line4 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 400 400"
      width="100%"
      height="100%"
      className={`RadialBadge_4 Badge ${className}`}
    >

      {/* ------------------------------------------ */}

      <defs>
        <path
          id="RadialBadge_4__TopCircle"
          d="M 38 200 A 50 50 0 0 1 362 200"
        />
        <path
          id="RadialBadge_4__BottomCircle"
          d="M 38 200 A 50 50 0 0 0 362 200"
        />
      </defs>

      {/* ------------------------------------------ */}

      <g>
        <circle cx="200" cy="200" r="200" className="Badge__ThirdFillColor" />
        <g>
          <g className="PIZZA">
            <g>
              <path
                d="M199.25,337.65C123.36,337.65,61.61,275.9,61.61,200S123.36,62.35,199.25,62.35,336.9,124.1,336.9,200,275.15,337.65,199.25,337.65Zm0-271.8C125.29,65.85,65.11,126,65.11,200s60.18,134.15,134.14,134.15S333.4,274,333.4,200,273.22,65.85,199.25,65.85Z"
                className="Badge__SecondFillColor"
              />
              <g>
                <path
                  d="M320.15,200h-3.5a36.36,36.36,0,0,1,1.27-8.25c.74-3.17,1.43-6.17,1-9s-2-5.64-3.59-8.52a36.32,36.32,0,0,1-3.45-7.36,36.59,36.59,0,0,1-1.09-8.19c-.19-3.27-.37-6.36-1.56-9s-3.45-4.82-5.82-7.12a36.2,36.2,0,0,1-5.42-6.11,36.12,36.12,0,0,1-3.35-7.52c-1.11-3.1-2.16-6-4-8.2s-4.64-3.63-7.55-5.16a36.22,36.22,0,0,1-7-4.38,35.94,35.94,0,0,1-5.3-6.25c-1.94-2.67-3.76-5.19-6.2-6.76s-5.45-2.17-8.67-2.82A36.78,36.78,0,0,1,248,93.18a35.65,35.65,0,0,1-6.8-4.47c-2.62-2-5.1-3.94-7.9-4.76s-5.81-.53-9.07-.25a36.47,36.47,0,0,1-8.29.08,35.37,35.37,0,0,1-7.75-2.36c-3.09-1.2-6-2.34-9-2.34s-5.87,1.14-9,2.34a35.37,35.37,0,0,1-7.75,2.36,36.47,36.47,0,0,1-8.29-.08c-3.26-.28-6.34-.55-9.07.25s-5.28,2.73-7.9,4.76a36.5,36.5,0,0,1-6.8,4.48,37.33,37.33,0,0,1-7.93,2.25c-3.22.65-6.26,1.27-8.68,2.83s-4.26,4.08-6.19,6.75a36.84,36.84,0,0,1-5.3,6.26,37,37,0,0,1-7,4.37c-2.91,1.54-5.66,3-7.55,5.17s-2.93,5.09-4,8.19a35.89,35.89,0,0,1-3.35,7.52,36.27,36.27,0,0,1-5.42,6.12c-2.37,2.29-4.61,4.47-5.82,7.11s-1.37,5.69-1.56,9a37.09,37.09,0,0,1-1.09,8.18,36.32,36.32,0,0,1-3.45,7.36c-1.63,2.88-3.17,5.61-3.59,8.52s.3,5.79,1,9A36.36,36.36,0,0,1,81.86,200h-3.5a33.19,33.19,0,0,0-1.18-7.45c-.78-3.35-1.58-6.81-1.09-10.26s2.28-6.7,4-9.74a33,33,0,0,0,3.14-6.62,33.63,33.63,0,0,0,1-7.41c.2-3.45.4-7,1.86-10.22s4.07-5.74,6.57-8.17a32.75,32.75,0,0,0,4.92-5.5,33.34,33.34,0,0,0,3-6.8c1.16-3.26,2.37-6.64,4.69-9.31s5.49-4.35,8.56-6a33.15,33.15,0,0,0,6.29-3.93,33.37,33.37,0,0,0,4.77-5.66c2-2.82,4.14-5.72,7.13-7.65s6.47-2.62,9.87-3.31A33.55,33.55,0,0,0,149,90a33.26,33.26,0,0,0,6.12-4.06c2.76-2.13,5.62-4.34,9.05-5.35s6.92-.67,10.36-.38a33.14,33.14,0,0,0,7.49.11,32,32,0,0,0,7-2.16c3.26-1.27,6.63-2.58,10.23-2.58s7,1.31,10.24,2.58a32.08,32.08,0,0,0,7,2.16,33.22,33.22,0,0,0,7.5-.11c3.44-.29,7-.6,10.36.38s6.28,3.21,9,5.35A33.32,33.32,0,0,0,249.49,90a33.39,33.39,0,0,0,7.17,2c3.39.69,6.9,1.4,9.87,3.31s5.09,4.83,7.13,7.64a33,33,0,0,0,4.76,5.67,32.9,32.9,0,0,0,6.3,3.92c3.07,1.62,6.24,3.3,8.56,6s3.53,6,4.69,9.31a33.34,33.34,0,0,0,3,6.8,33.15,33.15,0,0,0,4.92,5.5c2.5,2.42,5.08,4.93,6.56,8.17s1.67,6.77,1.87,10.22a33.71,33.71,0,0,0,1,7.41,32.92,32.92,0,0,0,3.14,6.61c1.72,3.05,3.49,6.19,4,9.75s-.32,6.91-1.09,10.26A33.19,33.19,0,0,0,320.15,200Z"
                  className="Badge__SecondFillColor"
                />
                <path
                  d="M318.4,201.75a1.75,1.75,0,0,1-1.75-1.75,36.36,36.36,0,0,1,1.27-8.25c.74-3.17,1.43-6.17,1-9s-2-5.64-3.59-8.52a36.32,36.32,0,0,1-3.45-7.36,36.59,36.59,0,0,1-1.09-8.19c-.19-3.27-.37-6.36-1.56-9s-3.45-4.82-5.82-7.12a36.2,36.2,0,0,1-5.42-6.11,36.12,36.12,0,0,1-3.35-7.52c-1.11-3.1-2.16-6-4-8.2s-4.64-3.63-7.55-5.16a36.22,36.22,0,0,1-7-4.38,35.94,35.94,0,0,1-5.3-6.25c-1.94-2.67-3.76-5.19-6.2-6.76s-5.45-2.17-8.67-2.82A36.78,36.78,0,0,1,248,93.18a35.65,35.65,0,0,1-6.8-4.47c-2.62-2-5.1-3.94-7.9-4.76s-5.81-.53-9.07-.25a36.47,36.47,0,0,1-8.29.08,35.37,35.37,0,0,1-7.75-2.36c-3.09-1.2-6-2.34-9-2.34s-5.87,1.14-9,2.34a35.37,35.37,0,0,1-7.75,2.36,36.47,36.47,0,0,1-8.29-.08c-3.26-.28-6.34-.55-9.07.25s-5.28,2.73-7.9,4.76a36.5,36.5,0,0,1-6.8,4.48,37.33,37.33,0,0,1-7.93,2.25c-3.22.65-6.26,1.27-8.68,2.83s-4.26,4.08-6.19,6.75a36.84,36.84,0,0,1-5.3,6.26,37,37,0,0,1-7,4.37c-2.91,1.54-5.66,3-7.55,5.17s-2.93,5.09-4,8.19a35.89,35.89,0,0,1-3.35,7.52,36.27,36.27,0,0,1-5.42,6.12c-2.37,2.29-4.61,4.47-5.82,7.11s-1.37,5.69-1.56,9a37.09,37.09,0,0,1-1.09,8.18,36.32,36.32,0,0,1-3.45,7.36c-1.63,2.88-3.17,5.61-3.59,8.52s.3,5.79,1,9A36.36,36.36,0,0,1,81.86,200a1.75,1.75,0,0,1-3.5,0,33.19,33.19,0,0,0-1.18-7.45c-.78-3.35-1.58-6.81-1.09-10.26s2.28-6.7,4-9.74a33,33,0,0,0,3.14-6.62,33.63,33.63,0,0,0,1-7.41c.2-3.45.4-7,1.86-10.22s4.07-5.74,6.57-8.17a32.75,32.75,0,0,0,4.92-5.5,33.34,33.34,0,0,0,3-6.8c1.16-3.26,2.37-6.64,4.69-9.31s5.49-4.35,8.56-6a33.15,33.15,0,0,0,6.29-3.93,33.37,33.37,0,0,0,4.77-5.66c2-2.82,4.14-5.72,7.13-7.65s6.47-2.62,9.87-3.31A33.55,33.55,0,0,0,149,90a33.26,33.26,0,0,0,6.12-4.06c2.76-2.13,5.62-4.34,9.05-5.35s6.92-.67,10.36-.38a33.14,33.14,0,0,0,7.49.11,32,32,0,0,0,7-2.16c3.26-1.27,6.63-2.58,10.23-2.58s7,1.31,10.24,2.58a32.08,32.08,0,0,0,7,2.16,33.22,33.22,0,0,0,7.5-.11c3.44-.29,7-.6,10.36.38s6.28,3.21,9,5.35A33.32,33.32,0,0,0,249.49,90a33.39,33.39,0,0,0,7.17,2c3.39.69,6.9,1.4,9.87,3.31s5.09,4.83,7.13,7.64a33,33,0,0,0,4.76,5.67,32.9,32.9,0,0,0,6.3,3.92c3.07,1.62,6.24,3.3,8.56,6s3.53,6,4.69,9.31a33.34,33.34,0,0,0,3,6.8,33.15,33.15,0,0,0,4.92,5.5c2.5,2.42,5.08,4.93,6.56,8.17s1.67,6.77,1.87,10.22a33.71,33.71,0,0,0,1,7.41,32.92,32.92,0,0,0,3.14,6.61c1.72,3.05,3.49,6.19,4,9.75s-.32,6.91-1.09,10.26a33.19,33.19,0,0,0-1.18,7.45A1.75,1.75,0,0,1,318.4,201.75Z"
                  className="Badge__SecondFillColor"
                />
              </g>
              <path
                d="M199.25,323.18c-3.6,0-6.89-1.66-10.07-3.26a24.22,24.22,0,0,0-7.05-2.73,24.76,24.76,0,0,0-7.73.65c-3.45.63-7,1.29-10.38.3s-6.12-3.52-8.71-5.94a24.46,24.46,0,0,0-6-4.64,25,25,0,0,0-7.54-1.56c-3.51-.37-7.13-.75-10.1-2.66s-4.84-5.08-6.64-8.13a24.78,24.78,0,0,0-4.5-6.18,24.68,24.68,0,0,0-6.78-3.6c-3.27-1.34-6.65-2.73-9-5.41s-3.21-6.2-4.08-9.63a24.73,24.73,0,0,0-2.6-7.23,24.59,24.59,0,0,0-5.47-5.32c-2.77-2.22-5.63-4.51-7.12-7.75s-1.32-6.83-1.19-10.35a24.66,24.66,0,0,0-.46-7.71,24.71,24.71,0,0,0-3.71-6.61c-2-2.92-4.15-5.93-4.65-9.49s.66-6.88,1.77-10.19A25,25,0,0,0,79,198.13a1.75,1.75,0,0,1,3.5,0,27.81,27.81,0,0,1-1.93,8.72c-1,3.07-2,6-1.63,8.59s2.17,5.28,4.06,8a27.51,27.51,0,0,1,4.2,7.62,27.78,27.78,0,0,1,.6,8.83c-.12,3.26-.24,6.33.88,8.77s3.55,4.42,6.11,6.46a27.64,27.64,0,0,1,6.23,6.17,27.61,27.61,0,0,1,3,8.26c.81,3.17,1.57,6.16,3.34,8.2s4.63,3.22,7.65,4.47a27.3,27.3,0,0,1,7.74,4.18,27.56,27.56,0,0,1,5.23,7.06c1.66,2.82,3.23,5.48,5.52,7s5.33,1.78,8.57,2.12a28,28,0,0,1,8.63,1.86,27.35,27.35,0,0,1,7,5.26c2.4,2.25,4.67,4.37,7.3,5.14s5.58.2,8.77-.38a27.65,27.65,0,0,1,8.86-.67,27.08,27.08,0,0,1,8.12,3.06c2.95,1.49,5.73,2.89,8.5,2.89s5.56-1.4,8.51-2.89a27.08,27.08,0,0,1,8.12-3.06,27.65,27.65,0,0,1,8.86.67c3.19.58,6.21,1.13,8.77.38s4.9-2.89,7.3-5.14a27.35,27.35,0,0,1,7-5.26,27.69,27.69,0,0,1,8.63-1.86c3.25-.34,6.31-.67,8.58-2.13s3.85-4.13,5.51-6.95a20.28,20.28,0,0,1,13-11.25c3-1.24,5.88-2.42,7.65-4.46s2.53-5,3.34-8.2a20.24,20.24,0,0,1,9.28-14.43c2.56-2,5-4,6.11-6.46s1-5.52.88-8.77a27.78,27.78,0,0,1,.6-8.83,27.26,27.26,0,0,1,4.2-7.62c1.89-2.7,3.67-5.25,4.06-8s-.6-5.51-1.63-8.58a27.81,27.81,0,0,1-1.93-8.72,1.75,1.75,0,0,1,3.5,0,25,25,0,0,0,1.75,7.61c1.11,3.31,2.26,6.75,1.77,10.19s-2.61,6.57-4.65,9.49a24.71,24.71,0,0,0-3.71,6.61,24.64,24.64,0,0,0-.46,7.71c.13,3.52.27,7.15-1.19,10.35s-4.35,5.53-7.12,7.75a24.53,24.53,0,0,0-5.46,5.32,24.45,24.45,0,0,0-2.61,7.23c-.87,3.42-1.77,7-4.08,9.63s-5.7,4.07-9,5.41a17.1,17.1,0,0,0-11.28,9.78c-1.8,3.05-3.65,6.21-6.64,8.13s-6.59,2.29-10.1,2.66a25.06,25.06,0,0,0-7.54,1.56,24.46,24.46,0,0,0-6,4.64c-2.59,2.42-5.27,4.94-8.71,5.94s-6.93.33-10.38-.3a24.76,24.76,0,0,0-7.73-.65,24.07,24.07,0,0,0-7,2.73C206.15,321.52,202.86,323.18,199.25,323.18Z"
                className="Badge__SecondFillColor"
              />
            </g>
            <g>
              <g>
                <rect
                  x="197.5"
                  y="79.09"
                  width="3.5"
                  height="241.81"
                  className="Badge__SecondFillColor"
                />
                <rect
                  x="78.35"
                  y="198.25"
                  width="241.81"
                  height="3.5"
                  className="Badge__SecondFillColor"
                />
                <rect
                  x="197.51"
                  y="79.09"
                  width="3.5"
                  height="241.81"
                  transform="translate(-83.06 199.47) rotate(-45)"
                  className="Badge__SecondFillColor"
                />
                <rect
                  x="78.35"
                  y="198.25"
                  width="241.81"
                  height="3.5"
                  transform="translate(-83.06 199.47) rotate(-45)"
                  className="Badge__SecondFillColor"
                />
              </g>
              <g>
                <g>
                  <path
                    d="M296.06,186.76a9.15,9.15,0,1,1,9.15-9.15A9.16,9.16,0,0,1,296.06,186.76Zm0-14.8a5.65,5.65,0,1,0,5.65,5.65A5.66,5.66,0,0,0,296.06,172Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M229,116.26a9.16,9.16,0,1,1,9.15-9.15A9.17,9.17,0,0,1,229,116.26Zm0-14.81a5.66,5.66,0,1,0,5.65,5.66A5.67,5.67,0,0,0,229,101.45Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M292.15,229.16A9.15,9.15,0,1,1,301.3,220,9.16,9.16,0,0,1,292.15,229.16Zm0-14.8A5.65,5.65,0,1,0,297.8,220,5.65,5.65,0,0,0,292.15,214.36Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M150,195.78a9.15,9.15,0,1,1,9.16-9.15A9.16,9.16,0,0,1,150,195.78Zm0-14.8a5.65,5.65,0,1,0,5.66,5.65A5.66,5.66,0,0,0,150,181Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M136.2,243.29a9.15,9.15,0,1,1,9.15-9.15A9.16,9.16,0,0,1,136.2,243.29Zm0-14.8a5.65,5.65,0,1,0,5.65,5.65A5.66,5.66,0,0,0,136.2,228.49Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M217.52,136.72a9.15,9.15,0,1,1,9.15-9.15A9.16,9.16,0,0,1,217.52,136.72Zm0-14.8a5.65,5.65,0,1,0,5.65,5.65A5.65,5.65,0,0,0,217.52,121.92Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M221.58,253.65a9.15,9.15,0,1,1,9.15-9.15A9.16,9.16,0,0,1,221.58,253.65Zm0-14.8a5.65,5.65,0,1,0,5.65,5.65A5.65,5.65,0,0,0,221.58,238.85Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M176.6,305a9.15,9.15,0,1,1,9.15-9.15A9.16,9.16,0,0,1,176.6,305Zm0-14.8a5.65,5.65,0,1,0,5.65,5.65A5.66,5.66,0,0,0,176.6,290.21Z"
                    className="Badge__SecondFillColor"
                  />
                </g>
                <g>
                  <path
                    d="M283.28,254.86a9.15,9.15,0,0,1-6.63-15.45l2.54,2.41a5.65,5.65,0,1,0,8.2,7.78l2.54,2.4a9.09,9.09,0,0,1-6.4,2.86Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M237.61,222.53a9.17,9.17,0,0,1-8.84-6.84l3.39-.89A5.65,5.65,0,1,0,243.09,212l3.39-.89a9.16,9.16,0,0,1-6.54,11.17A9.25,9.25,0,0,1,237.61,222.53Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M218,271.83l-.66,0a9.15,9.15,0,0,1-8.49-9.77l3.49.24a5.65,5.65,0,0,0,11.28.79l3.49.25a9.17,9.17,0,0,1-9.11,8.51Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M251.6,125.29a9.15,9.15,0,0,1-9.1-8.28l3.49-.33a5.66,5.66,0,0,0,6.16,5.09,5.66,5.66,0,0,0,5.09-6.16l3.48-.34a9.14,9.14,0,0,1-8.24,10A8.64,8.64,0,0,1,251.6,125.29Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M186,108.65l-2-2.88a5.65,5.65,0,1,0-6.45-9.28l-2-2.88a9.15,9.15,0,0,1,10.44,15Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M116.77,147a9.15,9.15,0,0,1-8.1-4.87l3.09-1.64a5.65,5.65,0,1,0,10-5.29l3.1-1.64A9.17,9.17,0,0,1,121,146,9,9,0,0,1,116.77,147Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M212.81,171.84a9.15,9.15,0,0,1,12.62-13.26L223,161.12a5.65,5.65,0,1,0-7.79,8.19Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M102.91,222.43a9.2,9.2,0,0,1-2.07-.24,9.15,9.15,0,0,1-6.84-11l3.41.8a5.63,5.63,0,0,0,4.22,6.78,5.65,5.65,0,0,0,6.78-4.22l3.41.79A9.16,9.16,0,0,1,102.91,222.43Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M152.31,228.05h-.26l.1-3.5a5.65,5.65,0,1,0,.32-11.3l.1-3.49a9.15,9.15,0,0,1-.26,18.29Z"
                    className="Badge__SecondFillColor"
                  />
                </g>
                <g>
                  <path
                    d="M259.8,236.12h0a1.8,1.8,0,0,1-1.23-.53l-5.4-5.59a1.75,1.75,0,0,1,0-2.47L267,214.17a1.8,1.8,0,0,1,1.25-.5,1.76,1.76,0,0,1,1.23.54l5.4,5.58a1.76,1.76,0,0,1,0,2.48L261,235.63A1.78,1.78,0,0,1,259.8,236.12Zm-2.92-7.29,3,3.07L271.15,221l-3-3.07Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M182.78,170a1.67,1.67,0,0,1-.62-.12,1.69,1.69,0,0,1-1-.92l-7.84-17.55a1.74,1.74,0,0,1,.88-2.31l7.1-3.17a1.75,1.75,0,0,1,2.31.89l7.84,17.55a1.75,1.75,0,0,1-.89,2.31l-7.09,3.17A1.79,1.79,0,0,1,182.78,170Zm-5.52-18.42L183.67,166l3.9-1.74-6.41-14.36Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M139.73,288.51a1.77,1.77,0,0,1-1.12-.4,1.72,1.72,0,0,1-.62-1.19l-.73-7.73a1.75,1.75,0,0,1,1.58-1.91L158,275.49a1.77,1.77,0,0,1,1.91,1.58l.72,7.74a1.75,1.75,0,0,1-1.58,1.9l-19.14,1.79Zm1.18-7.91.4,4.25L157,283.39l-.4-4.25Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M109.71,256.61a1.68,1.68,0,0,1-.72-.16l-7.09-3.2a1.75,1.75,0,0,1-.87-2.31l7.9-17.52a1.77,1.77,0,0,1,2.32-.88l7.08,3.2a1.71,1.71,0,0,1,.92,1,1.78,1.78,0,0,1,0,1.34l-7.91,17.52A1.76,1.76,0,0,1,109.71,256.61Zm-4.77-5.83,3.89,1.76,6.47-14.33-3.9-1.76Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M273,156.84a1.74,1.74,0,0,1-1.74-1.62l-.58-7.75a1.74,1.74,0,0,1,1.61-1.87l19.17-1.44a1.75,1.75,0,0,1,1.87,1.61l.58,7.75a1.74,1.74,0,0,1-1.61,1.88l-19.17,1.43Zm1.3-7.88.32,4.25L290.27,152l-.32-4.26Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M99.2,195.14a1.74,1.74,0,0,1-1.57-1L89.09,177a1.74,1.74,0,0,1-.09-1.34,1.75,1.75,0,0,1,.88-1l7-3.45a1.74,1.74,0,0,1,1.34-.09,1.75,1.75,0,0,1,1,.88l8.54,17.22a1.76,1.76,0,0,1-.79,2.34L100,195A1.74,1.74,0,0,1,99.2,195.14ZM93,177,100,191l3.82-1.89-7-14.09Z"
                    className="Badge__SecondFillColor"
                  />
                  <path
                    d="M236.6,151.48a1.73,1.73,0,0,1-.64-.12l-7.23-2.87a1.74,1.74,0,0,1-1-2.27L233,133a1.76,1.76,0,0,1,2.28-1l7.22,2.86a1.74,1.74,0,0,1,1,2.27l-5.21,13.19a1.75,1.75,0,0,1-.93,1A1.73,1.73,0,0,1,236.6,151.48Zm-4.95-5.6,4,1.58,3.92-9.94-4-1.57Z"
                    className="Badge__SecondFillColor"
                  />
                </g>
                <g>
                  <g>
                    <path
                      d="M260,192.78a3.76,3.76,0,0,1-1.24-.21l-9.35-3.33h0a3.72,3.72,0,0,1-2.18-4.94l.66-1.56a.22.22,0,0,0-.07-.27c-6.62-3.36-5.83-9.37-5.61-10.54a3.66,3.66,0,0,1,.17-.59,12.81,12.81,0,0,1,11.45-8.81,24.24,24.24,0,0,1,9.8,1.29,26.57,26.57,0,0,1,8.16,4.86c3.94,3.61,5.2,7.86,3.63,12.28-2.74,7.69-8.59,7.35-11,6.85a.22.22,0,0,0-.26.15l-.6,2.12a3.7,3.7,0,0,1-3.58,2.7Zm-9.42-6.84,9.35,3.33a.2.2,0,0,0,.17,0,.22.22,0,0,0,.11-.14l.6-2.12a3.71,3.71,0,0,1,4.35-2.61c3.29.69,5.63-.86,7-4.61,1.09-3.07.21-5.86-2.69-8.51a22.77,22.77,0,0,0-7-4.15,21.09,21.09,0,0,0-8.29-1.11,9.31,9.31,0,0,0-8.51,6.53c-.21,1.09-.53,4.64,3.75,6.81a3.71,3.71,0,0,1,1.7,4.75l-.65,1.56a.17.17,0,0,0,0,.17.17.17,0,0,0,.12.11Z"
                      className="Badge__SecondFillColor"
                    />
                    <g>
                      <path
                        d="M262.44,189.23a2,2,0,0,1-.41,0,1.75,1.75,0,0,1-1.29-2.11l1.74-7.09a2.94,2.94,0,0,1,4.71-1.6,5.22,5.22,0,0,1,1.64,6.11,3.81,3.81,0,0,1-4.39,2.2l-.3,1.21A1.74,1.74,0,0,1,262.44,189.23Zm2.83-5.95c.19,0,.27,0,.3-.08a2,2,0,0,0,0-1.3Zm.33-.13h0Z"
                        className="Badge__SecondFillColor"
                      />
                      <path
                        d="M249.52,184.92a1.81,1.81,0,0,1-.75-.16,1.77,1.77,0,0,1-.83-2.34l.4-.85a3.9,3.9,0,0,1-1.74-1.8,4,4,0,0,1-.14-3,5.22,5.22,0,0,1,5.11-3.68h0a2.9,2.9,0,0,1,2.47,1.37,2.93,2.93,0,0,1,.17,2.84l-3.13,6.59A1.74,1.74,0,0,1,249.52,184.92Zm1.07-8.07a2,2,0,0,0-.84,1.14.34.34,0,0,0,.1.4Z"
                        className="Badge__SecondFillColor"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      d="M124.79,183.79a3.81,3.81,0,0,1-.82-.09,3.76,3.76,0,0,1-2.38-1.74l-.85-1.46a.23.23,0,0,0-.26-.11c-6.66,3.31-11-.92-11.81-1.8a3,3,0,0,1-.37-.48,12.81,12.81,0,0,1-.23-14.45,24.21,24.21,0,0,1,6.89-7.08c4.85-3.24,15.42-7.25,20.79.77,4.54,6.8.77,11.29-1.07,12.91a.22.22,0,0,0,0,.29L136,172.3a3.72,3.72,0,0,1-.88,5.35l-8.25,5.51A3.76,3.76,0,0,1,124.79,183.79Zm-4.26-6.91a3.76,3.76,0,0,1,3.23,1.85l.85,1.46a.24.24,0,0,0,.14.1.19.19,0,0,0,.16,0h0l8.25-5.51a.21.21,0,0,0,.1-.14.22.22,0,0,0,0-.17l-1.34-1.75a3.73,3.73,0,0,1,.5-5.05c2.52-2.22,2.68-5,.47-8.33-4.78-7.15-15.82.11-15.93.19a20.83,20.83,0,0,0-5.84,6,9.27,9.27,0,0,0,.16,10.72c.74.82,3.4,3.2,7.69,1.07A3.59,3.59,0,0,1,120.53,176.88Z"
                      className="Badge__SecondFillColor"
                    />
                    <g>
                      <path
                        d="M133.26,173.37a1.76,1.76,0,0,1-1.35-.64l-4.65-5.62a2.94,2.94,0,0,1,1.53-4.73,5.24,5.24,0,0,1,5.89,2.33,3.8,3.8,0,0,1-.87,4.83l.8,1a1.75,1.75,0,0,1-1.35,2.87Zm-2.59-7.62.91,1.09c.12-.14.13-.23.11-.29A1.86,1.86,0,0,0,130.67,165.75Zm1,.75h0Z"
                        className="Badge__SecondFillColor"
                      />
                      <path
                        d="M122.09,181.16a1.76,1.76,0,0,1-1.55-.93l-.44-.83a3.9,3.9,0,0,1-2.49.32,4,4,0,0,1-2.46-1.66,5.2,5.2,0,0,1,.11-6.31,2.92,2.92,0,0,1,2.57-1.17,3,3,0,0,1,2.39,1.56l3.41,6.45a1.75,1.75,0,0,1-.72,2.37A1.84,1.84,0,0,1,122.09,181.16Zm-4.44-6.38a2,2,0,0,0,.42,1.35.34.34,0,0,0,.38.16Z"
                        className="Badge__SecondFillColor"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      d="M165.22,142.67a13.07,13.07,0,0,1-8.74-3.54,24.39,24.39,0,0,1-5.75-8,26.28,26.28,0,0,1-2-9.28c-.06-5.34,2.19-9.16,6.49-11,7.49-3.25,11.24,1.26,12.51,3.35a.21.21,0,0,0,.28.09l2-1a3.7,3.7,0,0,1,5.1,1.82l4,9.1a3.71,3.71,0,0,1-2.13,5l-1.58.58a.22.22,0,0,0-.16.23c2.07,7.14-2.87,10.67-3.88,11.3a3.35,3.35,0,0,1-.53.28A14,14,0,0,1,165.22,142.67Zm-5.09-29.53a9,9,0,0,0-3.53.84c-3,1.3-4.42,3.85-4.38,7.79a22.79,22.79,0,0,0,1.72,7.92,21,21,0,0,0,4.85,6.81,9.3,9.3,0,0,0,10.58,1.76c.94-.58,3.75-2.77,2.42-7.38a3.72,3.72,0,0,1,2.31-4.49l1.59-.59a.25.25,0,0,0,.12-.11.25.25,0,0,0,0-.17h0l-4-9.1a.18.18,0,0,0-.12-.12.2.2,0,0,0-.17,0l-2,1a3.73,3.73,0,0,1-4.88-1.39A5.16,5.16,0,0,0,160.13,113.14Z"
                      className="Badge__SecondFillColor"
                    />
                    <g>
                      <path
                        d="M161.85,121.24a3,3,0,0,1-1.4-.35,2.93,2.93,0,0,1-1.54-2.38,5.24,5.24,0,0,1,3.34-5.37,3.81,3.81,0,0,1,4.61,1.71l1.08-.61a1.75,1.75,0,1,1,1.72,3.05l-6.37,3.57A2.85,2.85,0,0,1,161.85,121.24Zm1.68-4.84a1.93,1.93,0,0,0-1,.86l1.24-.69C163.68,116.42,163.6,116.39,163.53,116.4Zm0,0h0Z"
                        className="Badge__SecondFillColor"
                      />
                      <path
                        d="M169.55,135.25a5.17,5.17,0,0,1-3.84-1.75,3,3,0,0,1,1.28-4.81l6.95-2.21a1.75,1.75,0,0,1,1.06,3.34l-.9.28a3.86,3.86,0,0,1-2.19,4.63A5.86,5.86,0,0,1,169.55,135.25Zm-.43-3.56a2.08,2.08,0,0,0,1.41-.17.35.35,0,0,0,.22-.35Z"
                        className="Badge__SecondFillColor"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      d="M242.62,301.7a3.57,3.57,0,0,1-.92-.12,3.71,3.71,0,0,1-2.33-1.8l-.82-1.48a.21.21,0,0,0-.25-.11c-6.75,3.12-11-1.22-11.76-2.12a3.34,3.34,0,0,1-.37-.51,12.82,12.82,0,0,1,.17-14.43,24.4,24.4,0,0,1,7.08-6.9c4.93-3.1,15.61-6.82,20.76,1.34,4.35,6.91.46,11.3-1.41,12.87a.22.22,0,0,0-.05.29l1.3,1.78a3.72,3.72,0,0,1-1,5.33l-8.39,5.29A3.79,3.79,0,0,1,242.62,301.7Zm-4.27-7a3.76,3.76,0,0,1,3.27,1.93l.81,1.48a.21.21,0,0,0,.14.1.18.18,0,0,0,.16,0h0l8.4-5.3a.19.19,0,0,0,.09-.14.22.22,0,0,0,0-.16l-1.3-1.78a3.74,3.74,0,0,1,.63-5c2.58-2.16,2.81-5,.69-8.32-4.58-7.27-15.81-.31-15.92-.24a21,21,0,0,0-6,5.83,9.29,9.29,0,0,0-.13,10.72c.72.84,3.31,3.29,7.67,1.27A3.68,3.68,0,0,1,238.35,294.68Z"
                      className="Badge__SecondFillColor"
                    />
                    <g>
                      <path
                        d="M251.31,291.51a1.74,1.74,0,0,1-1.38-.67l-4.5-5.75a3,3,0,0,1-.46-2.81,2.92,2.92,0,0,1,2.12-1.88,5.23,5.23,0,0,1,5.82,2.49,3.82,3.82,0,0,1-1,4.81l.77,1a1.75,1.75,0,0,1-1.38,2.83Zm-2.44-7.7.88,1.13c.16-.17.15-.27.15-.27A1.87,1.87,0,0,0,248.87,283.81Z"
                        className="Badge__SecondFillColor"
                      />
                      <path
                        d="M239.93,299a1.77,1.77,0,0,1-1.57-1l-.41-.85a4,4,0,0,1-2.5.26,4,4,0,0,1-2.42-1.73,5.22,5.22,0,0,1,.28-6.31,2.95,2.95,0,0,1,4.94.53l3.25,6.54a1.74,1.74,0,0,1-.79,2.34A1.69,1.69,0,0,1,239.93,299Zm-4.31-6.5a2,2,0,0,0,.38,1.36.34.34,0,0,0,.38.17Z"
                        className="Badge__SecondFillColor"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      d="M179.51,272.8a8.74,8.74,0,0,1-8.58-6.11.23.23,0,0,0-.27-.14l-2.12.6a3.73,3.73,0,0,1-4.64-2.8l-2.06-9.71a3.67,3.67,0,0,1,.57-2.88,3.71,3.71,0,0,1,2.5-1.56l1.67-.26a.2.2,0,0,0,.19-.2c-.6-7.4,4.93-9.88,6-10.3a5.54,5.54,0,0,1,.58-.17,12.84,12.84,0,0,1,13.51,5.15,24.3,24.3,0,0,1,4,9,26.64,26.64,0,0,1,.13,9.5c-1,5.25-4,8.54-8.55,9.52A14.76,14.76,0,0,1,179.51,272.8Zm-8.8-9.76a3.74,3.74,0,0,1,3.51,2.47c1.13,3.17,3.68,4.35,7.57,3.53,3.19-.68,5.1-2.89,5.84-6.76a22.74,22.74,0,0,0-.11-8.11,21.2,21.2,0,0,0-3.4-7.64,9.3,9.3,0,0,0-10-3.83c-1,.39-4.24,2-3.85,6.76a3.71,3.71,0,0,1-3.15,3.94l-1.67.26a.24.24,0,0,0-.15.09.22.22,0,0,0,0,.16h0l2.07,9.71a.22.22,0,0,0,.09.14.25.25,0,0,0,.17,0l2.12-.6A3.83,3.83,0,0,1,170.71,263Z"
                      className="Badge__SecondFillColor"
                    />
                    <g>
                      <path
                        d="M175.54,268.78a3.81,3.81,0,0,1-3.63-2.63l-1.19.38a1.75,1.75,0,0,1-1.07-3.33L176.6,261a2.95,2.95,0,0,1,3.83,3.18,5.23,5.23,0,0,1-4.35,4.6A3.12,3.12,0,0,1,175.54,268.78Zm0-3.49h0Zm-.28-.22c.08.17.17.21.23.22a2,2,0,0,0,1.12-.65Z"
                        className="Badge__SecondFillColor"
                      />
                      <path
                        d="M167.09,253.35a1.75,1.75,0,0,1-.19-3.49l.94-.1a3.91,3.91,0,0,1,.62-2.43,4,4,0,0,1,2.45-1.67,5.21,5.21,0,0,1,5.83,2.43,2.94,2.94,0,0,1-2.21,4.46l-7.25.79Zm5.16-4.34a3.79,3.79,0,0,0-.63.07.34.34,0,0,0-.28.3l1.7-.19A1.67,1.67,0,0,0,172.25,249Z"
                        className="Badge__SecondFillColor"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          {/*
          <g>
            <path d="M200,393v-3.5c104.48,0,189.48-85,189.48-189.48H393C393,306.41,306.41,393,200,393Z" className="Badge__SecondFillColor"/>
            <path d="M200,393C93.59,393,7,306.41,7,200h3.5c0,104.48,85,189.48,189.48,189.48Z" className="Badge__SecondFillColor"/>
            <path d="M10.52,200H7C7,93.59,93.59,7,200,7v3.5C95.52,10.52,10.52,95.52,10.52,200Z" className="Badge__SecondFillColor"/>
            <path d="M393,200h-3.5c0-104.48-85-189.48-189.48-189.48V7C306.41,7,393,93.59,393,200Z" className="Badge__SecondFillColor"/>
          </g>
*/}
        </g>
        <g>
          <polygon
            points="366.65 245.52 33.35 245.52 53.8 203.24 33.35 162.62 366.65 162.62 346.2 204.07 366.65 245.52"
            className="Badge__FirstFillColor"
          />
          <path
            d="M366.65,247.27H33.35a1.76,1.76,0,0,1-1.58-2.51l20.08-41.51L31.79,163.41a1.72,1.72,0,0,1,.07-1.7,1.75,1.75,0,0,1,1.49-.84h333.3a1.78,1.78,0,0,1,1.49.83,1.75,1.75,0,0,1,.08,1.7l-20.07,40.67,20.07,40.67a1.75,1.75,0,0,1-1.57,2.53Zm-330.51-3.5h327.7l-19.21-38.92a1.76,1.76,0,0,1,0-1.55l19.21-38.93H36.19l19.17,38.08a1.76,1.76,0,0,1,0,1.55Z"
            className="Badge__SecondFillColor"
          />
        </g>
      </g>

      {/* ------------------------------------------ */}

      <g className="TEXT">

        <text
          x="50%"
          y="50%"
          dy=".74ex"
          textAnchor="middle"
          fontFamily="Teko"
          fontSize="4em"
          fontWeight="700"
          letterSpacing=".35em"
          transform="translate(0,0)"
          className="Badge__ThirdFillColor"
        >
          {line2.toUpperCase()}
        </text>

        <text
          x=""
          y=""
          dy=".6ex"
          textAnchor="middle"
          fontFamily="Teko"
          fontSize="1.9em"
          fontWeight="700"
          letterSpacing="0.2em"
          className="Badge__FirstFillColor"
        >
          <textPath xlinkHref="#RadialBadge_4__TopCircle" startOffset="50%">
            {line1.toUpperCase()} {line2.toUpperCase()}
          </textPath>
        </text>

        <text
          x=""
          y=""
          dy=".65ex"
          textAnchor="middle"
          fontFamily="Teko"
          fontSize="1.9em"
          fontWeight="700"
          letterSpacing="0.2em"
          className="Badge__FirstFillColor"
        >
          <textPath xlinkHref="#RadialBadge_4__BottomCircle" startOffset="50%">
            {line3.toUpperCase()} {line4.toUpperCase()}
          </textPath>
        </text>

      </g>

      {/* ------------------------------------------ */}

    </svg>
  );
}

export default Badge;
